import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrderService {

  constructor(private http: HttpClient) { }

  getOrderDetails(id: any): Observable<any> {
    const url = `${environment.apiOrigin}/OrderService/api/order-details/customer/${id}`;
    return this.http.get(url);
  }

  getOrderSummary(criteria: any): Observable<any> {
    const url = `${environment.apiOrigin}/OrderService/api/order-summary-by-date`;
    return this.http.post(url, criteria);
  }

  getOrdersByDate(criteria: any): Observable<any> {
    const url = `${environment.apiOrigin}/OrderService/api/orders-by-date`;
    return this.http.post(url, criteria);
  }
}
